import 'angular-cookies'
import register from '../util/register'
import angular from 'angular'
import ngMessages from 'angular-messages'
import AccessToken from './AccessToken'
import AuthController from './AuthController'
import AuthInterceptor from './AuthInterceptor'
import AuthService from './AuthService'
import ComplexPassword from './ComplexPassword.directive'
import CurrentUserService from './CurrentUserService'
import User from './User'
import AnalyticsUserPropertiesService from './AnalyticsUserPropertiesService'
import UserRole from './UserRole'
import Base64 from '../util/base64.service.js';

var auth = angular.module(
  'app.auth',
  [
    'ngMessages',
    'app.templates',
    'ngCookies'
  ]
)

register('app.auth')
  .factory('AccessToken', AccessToken.factory)
  .factory('User', User.factory)
  .factory('UserRole', UserRole.factory)
  .factory('AuthInterceptor', AuthInterceptor.factory)
  .service('CurrentUserService', CurrentUserService)
  .service('AuthService', AuthService)
  .service('AnalyticsUserPropertiesService', AnalyticsUserPropertiesService)
  .service('Base64', Base64)
  .controller('AuthController', AuthController)
  .directive('complexPassword', ComplexPassword)

auth.config(['$httpProvider', $httpProvider => {
  $httpProvider.interceptors.push('AuthInterceptor')
}])
auth.run()
